// Redux
import { combineReducers } from 'redux';
// Redux Reducers
import lockScreenReducer from './transitionLockScreenReducer';
import transitionReducer from './transitionReducer';
import contextReducer from './contextReducer';
import settingReducers from './settingReducers';
import selectedDateReducer from './selectedDateReducer';
import widgetFiltersReducer from './widgetFiltersReducer';
import measuresReducer from './measuresReducer';
import unitsReducer from './unitsReducer';
import selectedSevenDaysReducer from './selectedSevenDaysReducer';
import userProfileReducer from './userProfileReducer';
import drawerReducer from './drawerReducer';

export default combineReducers({
  transitionLockScreen: lockScreenReducer,
  transition: transitionReducer,
  context: contextReducer,
  settings: settingReducers,
  selectedDate: selectedDateReducer,
  widgetFiltes: widgetFiltersReducer,
  measures: measuresReducer,
  units: unitsReducer,
  selectedSevenDays: selectedSevenDaysReducer,
  userProfile: userProfileReducer,
  drawer: drawerReducer
});
